import { createVNode, render } from 'vue'
import TipModal from './index.vue'

interface ItipModalConfig {
  title: string
  content?: string
}

interface ITipModalConfig {
  [key: string]: ItipModalConfig
}

// CHANNEL_LIMIT(-21,"渠道限制"),
// PHONE_ROLE_EMPTY(-22,"手机号登录角色为空")

const TIP_MODAL_CONFIG: ITipModalConfig = {
  '-21': {
    title: '亲爱的玩家：',
    content:
      '非常抱歉，您所登录的账号渠道暂未开放购买，您可以在游戏内享受充值服务，感谢您的支持与理解，祝您游戏愉快'
  },
  '-22': {
    title: '亲爱的玩家：',
    content: '当前账号未查询到游戏角色，请使用一键跳转登录、角色ID登录或更换手机号后重试！'
  }
}

const getTipModalConfig = (code: string) => {
  return TIP_MODAL_CONFIG[code]
}

let container: HTMLElement | null = null

// 显示提示弹窗
const showTipModal = (code: string) => {
  // 创建容器
  container = document.createElement('div')
  document.body.appendChild(container)

  // 获取配置
  const config = getTipModalConfig(code)

  // 创建 vnode
  const vnode = createVNode(TipModal, {
    modelValue: true,
    title: config.title,
    content: config.content,
    onClose: () => {
      render(null, container!)
      container && document.body.removeChild(container)
      container = null
    }
  })

  // 渲染到容器
  render(vnode, container)
}

// 关闭提示弹窗
const closeTipModal = () => {
  if (container) {
    render(null, container)
    document.body.removeChild(container)
    container = null
  }
}

export { showTipModal, closeTipModal }
